export const GET_ADMIN_SCHEDULED_REPORTS = "GET_ADMIN_SCHEDULED_REPORTS";
export const GET_ADMIN_SCHEDULED_REPORTS_SUCCESS = "GET_ADMIN_SCHEDULED_REPORTS_SUCCESS";
export const GET_ADMIN_SCHEDULED_REPORTS_ERROR = "GET_ADMIN_SCHEDULED_REPORTS_ERROR";

export const CREATE_ADMIN_SCHEDULED_REPORTS = "CREATE_ADMIN_SCHEDULED_REPORTS";
export const CREATE_ADMIN_SCHEDULED_REPORTS_SUCCESS = "CREATE_ADMIN_SCHEDULED_REPORTS_SUCCESS";
export const CREATE_ADMIN_SCHEDULED_REPORTS_ERROR = "CREATE_ADMIN_SCHEDULED_REPORTS_ERROR";

export const UPDATE_ADMIN_SCHEDULED_REPORTS = "UPDATE_ADMIN_SCHEDULED_REPORTS";
export const UPDATE_ADMIN_SCHEDULED_REPORTS_SUCCESS = "UPDATE_ADMIN_SCHEDULED_REPORTS_SUCCESS";
export const UPDATE_ADMIN_SCHEDULED_REPORTS_ERROR = "UPDATE_ADMIN_SCHEDULED_REPORTS_ERROR";

export const DELETE_ADMIN_SCHEDULED_REPORTS = "DELETE_ADMIN_SCHEDULED_REPORTS";
export const DELETE_ADMIN_SCHEDULED_REPORTS_SUCCESS = "DELETE_ADMIN_SCHEDULED_REPORTS_SUCCESS";
export const DELETE_ADMIN_SCHEDULED_REPORTS_ERROR = "DELETE_ADMIN_SCHEDULED_REPORTS_ERROR";

export const RESET_LAST_ADMIN_SCHEDULED_REPORTS_ACTION = "RESET_LAST_ADMIN_SCHEDULED_REPORTS_ACTION";

export const GET_ADMIN_SCHEDULED_REPORT_LOGS_BY_ID = "GET_ADMIN_SCHEDULED_REPORT_LOGS_BY_ID";
export const GET_ADMIN_SCHEDULED_REPORT_LOGS_BY_ID_SUCCESS = "GET_ADMIN_SCHEDULED_REPORT_LOGS_BY_ID_SUCCESS";
export const GET_ADMIN_SCHEDULED_REPORT_LOGS_BY_ID_ERROR = "GET_ADMIN_SCHEDULED_REPORT_LOGS_BY_ID_ERROR";

export const REDIRECT_TO_ADMIN_DOWNLOAD_URL = "REDIRECT_TO_ADMIN_DOWNLOAD_URL";
export const REDIRECT_TO_ADMIN_DOWNLOAD_URL_SUCCESS = "REDIRECT_TO_ADMIN_DOWNLOAD_URL_SUCCESS";
export const REDIRECT_TO_ADMIN_DOWNLOAD_URL_ERROR = "REDIRECT_TO_ADMIN_DOWNLOAD_URL_ERROR";
